import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f5114ff6 = () => interopDefault(import('../../../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _179c8bec = () => interopDefault(import('../../../pages/assessment/index.vue' /* webpackChunkName: "pages/assessment/index" */))
const _68eb440c = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _442fdc18 = () => interopDefault(import('../../../pages/case-studies/index.vue' /* webpackChunkName: "pages/case-studies/index" */))
const _07d27452 = () => interopDefault(import('../../../pages/contact-us.vue' /* webpackChunkName: "pages/contact-us" */))
const _7981e7a6 = () => interopDefault(import('../../../pages/industries/index.vue' /* webpackChunkName: "pages/industries/index" */))
const _72ab1bf0 = () => interopDefault(import('../../../pages/pages/index.vue' /* webpackChunkName: "pages/pages/index" */))
const _73b2ea48 = () => interopDefault(import('../../../pages/services/index.vue' /* webpackChunkName: "pages/services/index" */))
const _6734a2c4 = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _479d1ea8 = () => interopDefault(import('../../../pages/case-studies/_slug.vue' /* webpackChunkName: "pages/case-studies/_slug" */))
const _77cb465e = () => interopDefault(import('../../../pages/industries/_slug.vue' /* webpackChunkName: "pages/industries/_slug" */))
const _70f47aa8 = () => interopDefault(import('../../../pages/pages/_slug.vue' /* webpackChunkName: "pages/pages/_slug" */))
const _71fc4900 = () => interopDefault(import('../../../pages/services/_slug.vue' /* webpackChunkName: "pages/services/_slug" */))
const _53466d3b = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _f5114ff6,
    name: "about-us"
  }, {
    path: "/assessment",
    component: _179c8bec,
    name: "assessment"
  }, {
    path: "/blog",
    component: _68eb440c,
    name: "blog"
  }, {
    path: "/case-studies",
    component: _442fdc18,
    name: "case-studies"
  }, {
    path: "/contact-us",
    component: _07d27452,
    name: "contact-us"
  }, {
    path: "/industries",
    component: _7981e7a6,
    name: "industries"
  }, {
    path: "/pages",
    component: _72ab1bf0,
    name: "pages"
  }, {
    path: "/services",
    component: _73b2ea48,
    name: "services"
  }, {
    path: "/blog/:slug",
    component: _6734a2c4,
    name: "blog-slug"
  }, {
    path: "/case-studies/:slug?",
    component: _479d1ea8,
    name: "case-studies-slug"
  }, {
    path: "/industries/:slug",
    component: _77cb465e,
    name: "industries-slug"
  }, {
    path: "/pages/:slug",
    component: _70f47aa8,
    name: "pages-slug"
  }, {
    path: "/services/:slug",
    component: _71fc4900,
    name: "services-slug"
  }, {
    path: "/",
    component: _53466d3b,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
